/**
 * Created by chenzheyu on 2017/6/14.
 */
import XKinput from './src/input.vue'

XKinput.intall = function (Vue) {
  Vue.component(XKinput.name, XKinput)
}

export default XKinput



// WEBPACK FOOTER //
// ./src/components/module/input/index.js